<template>
  <!--
      作者：gmshop
      时间：2020-06-01
      描述：插件中心-合同-添加
    -->
  <div class="product-add pb50">
   <!--添加合同-->
    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加合同</div>
      <el-form-item label="合同标题" prop="title"><el-input v-model="form.title" placeholder="请输入合同标题" class="max-w460"></el-input></el-form-item>
      <el-form-item label="变量字段" prop="variable" >
        <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick">添加时段</el-button><div class="tips">变量名称实例：[名称]=[订单号]</div>
        <el-table :data="form.variable" border  style="width: 60%">
            <el-table-column label="变量名称" width="120px">
                <template slot-scope="scope">
                    <el-form-item :prop="'variable.'+ scope.$index + '.name'" :rules="[{ required: true, message: ' ' }]">
                        <el-input type="text" v-model="scope.row.name" autocomplete="off"></el-input>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column label="类型" width="150px">
                <template slot-scope="scope">
                    <el-form-item :prop="'variable.'+ scope.$index + '.type'" :rules="[{ required: true, message: ' ' }]">
                        <el-select @change="clearContent(scope.$index)" v-model="scope.row.type" placeholder="">
                          <el-option label="变量" :value="1"></el-option>
                          <el-option label="文字" :value="2"></el-option>
                          <el-option label="图片" :value="3"></el-option>
                        </el-select>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column label="内容">
                <template slot-scope="scope">
                    <el-form-item :prop="'variable.'+ scope.$index + '.content'" :rules="[{ required: true, message: ' ' }]">
                        <div class="d-s-c mt16" v-if="scope.row.type == 1">
                          <el-select v-model="scope.row.content" filterable placeholder="请选择">
                            <el-option
                              v-for="item,index in variable"
                              :key="index"
                              :label="item.text"
                              :value="index">
                            </el-option>
                          </el-select>
                          <el-input v-if="scope.row.content == 'sign'" style="max-width: 150px;" type="number" v-model="scope.row.width"><template slot="append">宽px</template></el-input>
                          <el-input v-if="scope.row.content == 'sign'" style="max-width: 150px;" type="number" v-model="scope.row.height"><template slot="append">高px</template></el-input>
                        </div>
                        <el-input v-if="scope.row.type == 2" type="text" v-model="scope.row.content" autocomplete="off"></el-input>
                        <template v-if="scope.row.type == 3">
                          <el-row :gutter="10">
                            <el-col :span="4">
                              <img v-img-url="scope.row.content" @click="openUpload(scope.$index)" :model="scope.row.content" width="35px"/>
                            </el-col>
                            <el-col :span="8">
                              <el-input type="number" v-model="scope.row.width"><template slot="append">宽px</template></el-input>
                            </el-col>
                            <el-col :span="8">
                              <el-input type="number" v-model="scope.row.height"><template slot="append">高px</template></el-input>
                            </el-col>
                          </el-row>
                        </template>
                    </el-form-item>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="80px">
              <template slot-scope="scope">
                  <el-button @click="delClick(scope.$index)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
        </el-table>
      </el-form-item>
      <el-form-item label="合同内容">
        <div class="edit_container">
          <Uediter v-model="form.content" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>
      <el-form-item label="默认">
         <el-radio-group v-model="form.is_default">
           <el-radio :label="1">是</el-radio>
           <el-radio :label="0">否</el-radio>
         </el-radio-group>
       </el-form-item>
      <el-form-item label="合同状态">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">显示</el-radio>
          <el-radio :label="0">隐藏</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="排序"><el-input type="number" v-model="form.sort" placeholder="请输入数字" class="max-w460"></el-input></el-form-item>
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import ContractApi from '@/api/plus/contract.js';
import Uediter from '@/components/UE.vue';
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*编辑器*/
    Uediter,
    /*图片上传*/
    Upload: Upload
  },
  created(){
    this.getData();
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,
      /*左边长度*/
      formLabelWidth: '80px',
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      path: '',
      /*form表单数据*/
      form: {
        title: '',
        sort: 1,
        is_default: 1,
        status: 1,
        content: '',
        variable: [],
      },
      variable: [],
      loading: false,
      variable_index: '',
      /*验证规则*/
      rules: {
        title: [{ required: true, message: '请输入合同标题', trigger: 'blur' }],
        variable: [{ required: true, message: '请添加字段', trigger: 'blur' }],
        dec: [{ required: true, message: '请输入合同描述', trigger: 'blur' }]
      }
    };
  },
  methods: {
    getData(){
      this.loading = true;
      ContractApi.getData({}, true)
        .then(data => {
          this.variable = data.data.variable
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
        });
    },
    /**
     * 变动清除内容
     */
    clearContent(index){
      this.form.variable[index].content = ''
    },
    /*添加合同*/
    onSubmit() {
      let self = this;
      let form = self.form;
      self.form.content = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          ContractApi.addContract(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.$router.push('/plus/contract/contract/index');
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*上传*/
    openUpload(index) {
      this.isupload = true;
      this.variable_index = index;
    },

    /*获取图片*/
    returnImgsFunc(e) {
      let self = this;
      if (e != null) {
        this.$set(self.form.variable[self.variable_index], 'content', e[0]['file_path']);
      }
      this.isupload = false;
    },

    /*取消添加，返回合同列表*/
    cancelFunc() {
      this.$router.push({
        path: '/plus/contract/contract/index'
      });
    },
    /**
       * 添加默认数据
       */
      addClick() {
          this.form.variable.push({name:'',type:1,content:''});
      },
      /**
       * 删除
       */
      delClick(index) {
          this.form.variable.splice(index,1)
      },
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/contract/contract/add.vue